import axios from 'axios'
import qs from 'qs'
import { yiapiRequestGet, yiapiRequestPost } from './common'
import { getEnvHost } from 'lib/tools/getPlatform'

const isServer = process.env.VUE_ENV === 'server'

let mHost = 'https://m.xinli001.com/'
let yiappHost = 'https://yiapp.xinli001.com/'
let yiapiHost = 'https://yiapi.xinli001.com/'

// 兼容服务端渲染
if (!isServer) yiappHost = `${getEnvHost(yiappHost)}`

// 基础资料
export const getBasicInfo = params =>
  axios.get(`${mHost}user_home/basic`, { params })

// 提供服务（全局）
export const getServiceInfo = params =>
  axios.get(`${mHost}user_home/services`, { params })

// 提供服务（咨询独有）
export const getConsultService = params =>
  axios.get(`${mHost}user_home/consult_service`, { params })

// 用户关系（是否关注/拉黑等）
export const getUserRelation = data =>
  axios.post(`${mHost}user_home/user_relation`, data)

export const checkPsychicOrder = params =>
  axios.get(`${mHost}user_home/psychic_coach_order_check`, { params })

// 领取优惠券
export const getCoupon = ({ id }) =>
  axios.get(`${mHost}coupon/receivecoupon`, {
    params: { coupon_id: id }
  })

// 关注
export const postSubscribe = data =>
  yiapiRequestPost(`${yiappHost}commonOperate/subscribe`, data)

// 拉黑
export const postBlock = data =>
  yiapiRequestPost(`${yiapiHost}v7/yi/im/user-black.json`, data)

// 给评价内容点赞
export const ratezan = ({ id }) =>
  axios.post(`${mHost}webzixun/ratezan`, qs.stringify({ id }))

// 咨询师主页浏览记录
export const teacherBrowse = params =>
  axios.get(`${mHost}consultteacher/browse`, { params })

// 心探教练 修改陪聊状态
export const xinTanChangeStatus = data =>
  axios.post(`${mHost}psychic-coach/change-work-status.json`, data)

// 获取动态列表
export const getDynamicList = params =>
  yiapiRequestGet(`${yiappHost}authUser/tabList`, params)

// 获取tab列表
export const businesses = params =>
  yiapiRequestGet(`${mHost}user_home/businesses`, params)

// 获取评价列表
export const getRateList = params =>
  yiapiRequestGet(`${mHost}consultteacher/ratelist`, params)

// 查询是否能提问
export const getUserInviteNum = params =>
  yiapiRequestGet(`${mHost}qa/get-user-invite-num.json`, params)

// 获取海报二维码
export const fetchQrcode = params =>
  yiapiRequestGet(`${mHost}common/qr-code`, params)

// 咨询师自动回复
export const sendAutoReplyApi = params =>
  axios.post(`${mHost}consult/activity/send-auto-reply`, params)

// 老师相册，视频
export const talkVideos = params =>
  axios.get(`${mHost}consult/talk_videos`, { params })

// 主题信息接口
export const activityInfo = params =>
  axios.get(`${mHost}consult_activity/common/activity-info`, { params })

// 参与主题检查接口
export const activityJoinCheck = params =>
  axios.get(`${mHost}consult_activity/common/join-check`, {
    params,
    disabledUnLoginInterceptors: true
  })

// 获取套餐详情接口
export const pkgDetailApi = params =>
  axios.get(`${mHost}consult_activity/common/package-activity-info`, {
    params
  })

// 预取订单价格
export const preOrderInfo = data =>
  axios.post(`${mHost}consult_order/pre_create_order_info`, data)
// 倾听师信息
export const getQingsuService = params =>
  axios.get(`${mHost}new-qingsu/qingting-index`, { params })

// 获取倾诉评价列表
export const getQingsuRateList = params =>
  yiapiRequestGet(`${mHost}new-qingsu/rate-list`, params)

// 是否倾诉新来访
export const getQingsuNewVisit = params =>
  axios.get(`${mHost}new-qingsu/user-visit`, { params })

// 倾诉获取上线提醒
export const getQingsuReminder = params =>
  axios.get(`${mHost}new-qingsu/get-user-online-reminder`, { params })

// 倾诉设置上线提醒
export const setQingsuReminder = data =>
  axios.post(`${mHost}new-qingsu/set-online-reminder`, data)

// 倾诉渠道信息
export const getChannelInfo = params =>
  axios.get(`${mHost}webzixun/channel-info`, { params })

// 倾诉师站外推广
export const bindPromote = params =>
  axios.post(`${mHost}promote/bind_info`, params)
